const phases = {
    UNDEFINED: 'UNDEFINED',
    INTRO: 'INTRO',
    PRE_SEASON: 'PRE_SEASON',
    PRE_RACE: 'PRE_RACE',
    RACE: 'RACE',
    POST_RACE: 'POST_RACE',
    POST_SEASON: 'POST_SEASON'
}

export function phaseToNumber(phase) {
    if (typeof phase === 'number') return phase
    if (phase === phases.INTRO) return 0
    if (phase === phases.PRE_SEASON) return 1
    if (phase === phases.PRE_RACE) return 2
    if (phase === phases.RACE) return 3
    if (phase === phases.POST_RACE) return 4
    if (phase === phases.POST_SEASON) return 5
    return -1
}

export function isBefore(phase, referencePhase) {
    return phaseToNumber(phase) < phaseToNumber(referencePhase)
}
export function isBeforeOrEqual(phase, referencePhase) {
    return phaseToNumber(phase) <= phaseToNumber(referencePhase)
}
export function isAfter(phase, referencePhase) {
    return phaseToNumber(phase) > phaseToNumber(referencePhase)
}
export function isAfterOrEqual(phase, referencePhase) {
    return phaseToNumber(phase) >= phaseToNumber(referencePhase)
}

export default phases



// WEBPACK FOOTER //
// src/utils/constants/phases.js